import React from "react";
import { Box, Typography } from "@mui/material";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

// A segmented progress-bar that visually represents the capacity level
const CapacityBar = ({ color, segments = 5, filled }) => (
  <Box sx={{ display: "flex", gap: "4px" }}>
    {[...Array(segments)].map((_, i) => (
      <Box
        key={i}
        sx={{
          width: 16,
          height: 28,
          borderRadius: "4px",
          background: i < filled ? color : "rgba(0,0,0,0.1)",
          boxShadow: i < filled ? `0 0 6px ${color}55` : "none",
        }}
      />
    ))}
  </Box>
);

const CAPACITY_OPTIONS = [
  {
    key: "single",
    label: "Not much",
    description: "Let's keep it simple. One thing at a time.",
    bar: <CapacityBar filled={1} color="#e74c3c" />,
  },
  {
    key: "few",
    label: "A bit",
    description: "Somewhere in the middle. We can handle a few things.",
    bar: <CapacityBar filled={3} color="#f39c12" />,
  },
  {
    key: "many",
    label: "A lot",
    description: "Got a lot to give today? Let's make the most of it.",
    bar: <CapacityBar filled={5} color="#27ae60" />,
  },
];

/**
 * Asks the user about their capacity for the day.
 * Three card options: single / few / many.
 */
const CapacityStep = ({ selected, onSelect }) => {
  return (
    <Box className="task-guide-step task-guide-step--capacity">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          How much can you handle today?
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-step__option-cards">
        {CAPACITY_OPTIONS.map((option) => (
          <Box
            key={option.key}
            className={`task-guide-step__option-card ${selected === option.key ? "task-guide-step__option-card--selected" : ""}`}
            onClick={() => onSelect(option.key)}
          >
            <Box
              className="task-guide-step__option-icon"
              sx={{
                width: "auto !important",
                minWidth: "unset !important",
                padding: "0 16px",
                marginRight: "12px",
                "@media (max-width: 380px)": {
                  marginRight: "0 !important",
                  padding: "0 !important",
                },
              }}
            >
              {option.bar}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                gap: "6px",
                "@media (max-width: 380px)": {
                  flex: "unset",
                },
              }}
            >
              <Typography
                variant="h3"
                className="task-guide-step__option-label"
              >
                {option.label}
              </Typography>
              <Typography
                variant="body2"
                className="task-guide-step__option-desc"
              >
                {option.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CapacityStep;
